import { ReactElement } from 'react';
import { Box, Typography } from '@mui/material';

export const GlobalNotFoundPage = (): ReactElement => {
  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        margin: 0,
        padding: 0,
        backgroundColor: 'black',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Typography
          sx={{
            fontFamily: 'LemonMilkMedium',
            fontSize: 45,
            color: 'white',
            textAlign: 'center',
          }}
        >
          Page Not Found
        </Typography>
      </Box>
    </Box>
  );
};

export default GlobalNotFoundPage;
